module.exports = __webpack_public_path__ + "static/img/ASHTON-MOIR.a300521.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ASHTON-MOIR.jpg
// module id = 4AL1
// module chunks = 0